import { useEffect, useState } from 'react';

const STORAGE_KEY = 'tracker-expanded-ready-months';

function loadFromStorage(): Record<string, boolean> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    const out: Record<string, boolean> = {};
    for (const [k, v] of Object.entries(parsed as Record<string, unknown>)) {
      if (typeof k !== 'string') continue;
      if (v === true) out[k] = true;
    }
    return out;
  } catch {
    return {};
  }
}

function saveToStorage(state: Record<string, boolean>): void {
  try {
    const compact: Record<string, boolean> = {};
    for (const [k, v] of Object.entries(state)) {
      if (v) compact[k] = true;
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(compact));
  } catch {
    // ignore
  }
}

export function useExpandedReadyMonths(): {
  expandedReadyMonths: Record<string, boolean>;
  setExpandedReadyMonths: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
} {
  const [expandedReadyMonths, setExpandedReadyMonths] =
    useState<Record<string, boolean>>(loadFromStorage);

  useEffect(() => {
    saveToStorage(expandedReadyMonths);
  }, [expandedReadyMonths]);

  return { expandedReadyMonths, setExpandedReadyMonths };
}
